<div class="ManipSubtractingBlocks">
    <div>
        <div [class.Squeeze]="canSqueezeBlocks">
            <div class="TopRow">
                <div class="block_counter" [ngClass]="{grey: value === 0, IsNeg: value < 0}">
                    {{value | numWithSign | minusToDash}}
                </div>

                <div class="BlockContainer" *ngFor="let block of fixedBlocks"
                     [ngClass]="{IsZeroPair: block.isZeroPair}">
                    <div class="Block" [ngClass]="{BlockHidden: block.value === 0, IsNeg: block.value === -1}">
                        <span *ngIf="block.value !== 0">{{block.value | numWithSign | minusToDash}}</span>
                        <span *ngIf="block.value === 0">X</span>
                    </div>
                </div>
                <div class="BlockContainer" *ngFor="let block of topRow" [ngClass]="{IsZeroPair: block.isZeroPair}">
                    <div class="Block animated bounceIn"
                         [ngClass]="{BlockHidden: block.value === 0, IsNeg: block.value === -1}">
                        <span *ngIf="block.value !== 0">{{block.value | numWithSign | minusToDash}}</span>
                        <span *ngIf="block.value === 0">X</span>
                    </div>
                </div>
            </div>

            <div *ngIf="!singleRow" class="BottomRow">
                <div class="block_counter">&nbsp;</div>
                <div class="BlockContainer" *ngFor="let block of fixedBlocks">
                    <div class="Block Empty">&nbsp;</div>
                </div>

                <div *ngFor="let block of bottomRow" class="BlockContainer" [ngClass]="{IsZeroPair: block.isZeroPair}">
                    <div class="Block animated bounceIn"
                         [ngClass]="{BlockHidden: block.value === 0, IsNeg: block.value === -1}">
                        <span *ngIf="block.value !== 0">{{block.value | numWithSign | minusToDash}}</span>
                        <span *ngIf="block.value === 0">X</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="BlockSummary">
            {{expression | minusToDash}} = {{value | numWithSign | minusToDash}}
        </div>
    </div>
    <div *ngIf="!(hideStudentManipControlBar | async)"
        class="ManipAlgebraTilesBar StudentManipControlBar StudentManipControlBarBottomOnMobile">
        <div class="kh-bottom-bar-container w-100 d-flex justify-content-center align-content-center kh-horizontal-scroll-bar ">
            <div
                class="kh-bottom-bar-content-container w-100 d-flex justify-content-between align-items-center  flex-shrink-0">
                <div class="w-100 d-flex align-items-center   flex-shrink-0 flex-grow-1">
                    <div class=" d-flex align-items-center kh-justify-content-align-controls  flex-shrink-0 flex-grow-1">
                        <button #add type="button" (click)="removeBlock()"
                            class="btn-md kh-blue-button white kh-lg-title-text text-uppercase kh-no-wrap  kh-secondory-controls">
                            Subtract
                            <span *ngIf="term[1] < 0">–</span>
                            <span *ngIf="term[1] > 0">+</span>
                            1
                        </button>
                        <button #substract type="button" *ngIf="!singleRow" (click)="addZeroPair()"
                            class="btn-md kh-blue-button white kh-lg-title-text text-uppercase kh-no-wrap  kh-secondory-controls">
                            Add Zero
                            Pair
                        </button>
                        <button #resetBlock type="button"
                            class="btn-md kh-blue-button white kh-lg-title-text text-uppercase kh-no-wrap  kh-secondory-controls mr-2"
                            (click)="resetClick()"><fa-icon [icon]="['fas','redo']" class="mr-2"></fa-icon>Reset</button>
                    </div>
                    <div class="justify-content-end kh-submit-width  flex-shrink-0 ">
                        <button
                            class="btn-md kh-green-button kh-green-accessible white kh-lg-title-text text-uppercase kh-no-wrap  manipulative-submit-button  "
                            type="button" *ngIf="isManipChanged && !questionClosed" (click)="submit()"
                            [class.animated]="isManipChanged"><img
                                src="https://staticcontent.knowledgehook.com/content/icons/question/submitarrow-onprimary.svg">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
